import TopHeader from "../component/TopHeader";
import Secondheader from "../component/Second_header";
import React, { useState, useEffect } from "react";
import axios from "axios";
import '../component/css/Profilepersonal.css';
import ProfileImg from "../Image/profile.png";

const Profilepersonal = () => {
  const [activeSection, setActiveSection] = useState("PersonalInformation");
  const [name, setName] = useState('');
  const [phone, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [preferences, setPreferences] = useState({
    language: '',
    timeFormat: '',
    timeZone: '',
    country: '',
    grouping: '',
    decimal: ''
  });
  const [isPreferencesAvailable, setIsPreferencesAvailable] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingPhone, setIsEditingPhone] = useState(false);
  const [savingPhone, setSavingPhone] = useState(false);
  const [address, setAddress] = useState({
    street: '', city: '', state: '', zip: '', country: ''
  });
  const [loading, setLoading] = useState(false);
  const [loadingPersonal, setLoadingPersonal] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [preferencesEmpty, setPreferencesEmpty] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const nameFirst = sessionStorage.getItem('first_name');
  const Email = sessionStorage.getItem("email")

  

  const fetchPersonalData = async () => {
    try {
      const response = await axios.get(`/server/jad_group_website_function/user-profile`, {
        params: { email: sessionStorage.getItem("email") }
      });
      if (response.data) {
        setEmail(response.data.Email || '');
        setPhoneNumber(response.data.Phone || '');
        setAddress({
          street: response.data.Mailing_Street || '',
          city: response.data.Mailing_City || '',
          state: response.data.Mailing_State || '',
          zip: response.data.Mailing_Zip || '',
          country: response.data.Mailing_Country || '',
        });
      }
    } catch (error) {
      console.error("There was an error fetching the personal data:", error);
    }
  };
  const userId = sessionStorage.getItem("ProfileID")


  const fetchPreferencesData = async () => {
    try {
      const ProfileID = localStorage.getItem("ProfileID");
  
      if (!ProfileID) {
        console.error("No ProfileID found in localStorage.");
        setPreferencesEmpty(true);
        setIsPreferencesAvailable(false);
        return;
      }
  
      const apiUrl = `/server/user-preferences/user-preference-details?User_Id=${ProfileID}`;
      console.log("Fetching preferences with ProfileID:", ProfileID); 
  
      const response = await axios.get(apiUrl);
  
      if (!response.data || Object.keys(response.data).length === 0) {
        setPreferencesEmpty(true);
        setIsPreferencesAvailable(false);
        return;
      }
  
      const {
        Preferred_Language,
        Preferred_Time_Zone,
        Preferrred_Time_Format,
        Preferred_Country,
        Preferred_Grouping,
        Preferred_Decimal,
        Phone,
      } = response.data;

      if (Phone) {
        setPhoneNumber(Phone);
      }
  
      setPreferences({
        language: Preferred_Language || '',
        timeFormat: Preferrred_Time_Format || '',
        timeZone: Preferred_Time_Zone || '',
        country: Preferred_Country || '',
        grouping: Preferred_Grouping || '',
        decimal: Preferred_Decimal || '',
      });
  
      const isEmpty = Object.values(response.data).every(value => !value);
      setPreferencesEmpty(isEmpty);
      setIsPreferencesAvailable(!isEmpty);
    } catch (error) {
      console.error("Error fetching user preferences data:", error);
      setPreferencesEmpty(true);
      setIsPreferencesAvailable(false);
    }
  };
  

  
  
  

  useEffect(() => {
    if (activeSection === "PersonalInformation") {
      setLoadingPersonal(true);
      const timer = setTimeout(async () => {
        await fetchPersonalData();
        setLoadingPersonal(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [activeSection]);

  useEffect(() => {
    if (activeSection === "UserPreferences") {
      setLoading(true);
      const timer = setTimeout(async () => {
        await fetchPreferencesData();
        setLoading(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [activeSection]);

  const handleButtonClick = (section) => {
    setActiveSection(section);
  };

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();

    const data = {
      email,
      oldPassword,
      newPassword
    };

    try {
      await axios.post("/post_password.php", data, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log("Password changed successfully");
    } catch (error) {
      console.error("There was an error changing the password:", error);
    }

    setOldPassword('');
    setNewPassword('');
    event.target.reset();
  };

  const handlePreferencesSubmit = async (event) => {
    event.preventDefault();
  
    const preferencesData = {
      Email,
      language: event.target.language.value,
      timeFormat: event.target.timeFormat.value,
      timeZone: event.target.timeZone.value,
      country: event.target.country.value,
      grouping: event.target.grouping.value,
      decimal: event.target.decimal.value,
    };
  
    try {
      if (preferencesEmpty) {
        // Create Preferences
        const response = await axios.post('/server/user-preferences/create-user-preferences', preferencesData, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        const { ProfileID, message } = response.data;
  
        if (ProfileID) {
          localStorage.setItem("ProfileID", ProfileID); // Store ProfileID in localStorage
          console.log("ProfileID stored in localStorage:", ProfileID);
        } else {
          console.error("ProfileID is missing in the response.");
        }
  
        setSuccessMessage(message || "User preferences created successfully");
      } else {
        // Update Preferences
        const ProfileID = localStorage.getItem("ProfileID"); // Retrieve ProfileID from localStorage
        if (!ProfileID) {
          console.error("No ProfileID found in localStorage. PUT request cannot proceed.");
          setSuccessMessage("ProfileID is missing. Unable to update preferences.");
          return;
        }
  
        const apiUrl = `/server/user-preferences/edit-user-preferences?ProfileID=${ProfileID}`;
        await axios.put(apiUrl, preferencesData, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        setSuccessMessage("Data updated successfully");
      }
  
      await fetchPreferencesData(); // Fetch updated preferences
      setIsEditing(false);
    } catch (error) {
      console.error("Error saving/updating user preferences:", error);
      setSuccessMessage("An error occurred while updating preferences.");
    }
  
    event.target.reset();
  };
  

  
  

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handlePhoneSave = async () => {
    // Validate phone: only digits, spaces, hyphens, plus, parentheses, min 7 chars
    const phoneRegex = /^[+]?[\d\s\-()]{7,20}$/;
    if (phone && !phoneRegex.test(phone)) {
      setSuccessMessage("Please enter a valid phone number (digits, spaces, hyphens only).");
      return;
    }
    setSavingPhone(true);
    try {
      await axios.put(`/server/jad_group_website_function/update-phone?email=${Email}`, {
        phone,
      });
      setSuccessMessage("Phone number updated successfully");
      setIsEditingPhone(false);
    } catch (error) {
      console.error("Error saving phone:", error);
      setSuccessMessage("Error saving phone number");
    } finally {
      setSavingPhone(false);
    }
  };
  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  return (
    <div className="CMAMachines_box">
      <TopHeader />
      <div className="secondHeader-fixed-style">
        <Secondheader />
      </div>
      {successMessage && (
        <div className="popup-overlay">
          <p className="submitted-message">{successMessage}</p>
        </div>
      )}
      <div className="Profilepersonal_box">
        <div className="Profilepersonal_Tab">
          <h1>
            <b>Profile</b> Settings
          </h1>
          <div className="Buttons">
            <a
              className={activeSection === "PersonalInformation" ? "ActiveBoxx" : ""}
              onClick={() => handleButtonClick("PersonalInformation")}
            >
              <img
                src={ProfileImg}
                className="Profile_img"
              />
              Personal
            </a>
            <a
              className={activeSection === "UserPreferences" ? "ActiveBoxx" : ""}
              onClick={() => handleButtonClick("UserPreferences")}
            >
              <img
                src={ProfileImg}
                className="Profile_img"
              />
              User preferences
            </a>
          </div>
        </div>
        <div className="Profilepersonal_Boxes">
          <div
            className={`Information ${activeSection === "PersonalInformation" ? "" : "d-none"}`}
          >
            <div className="PersonalInformation_In">
              <h1 className="personal_information">Personal Information</h1>
              <p>This includes your name, email address, password</p>
              {loadingPersonal ? (
                <div className="loader"></div>
              ) : (
                <form onSubmit={handlePasswordSubmit} className="Personal_details">
                  <div className="Selection_bar">
                    <div className="Selection_">
                      <label htmlFor="name">Your name</label>
                      <input
                        placeholder=""
                        type="text"
                        id="name"
                        name="name"
                        value={ nameFirst}
                        onChange={(e) => setName(e.target.value)}
                        required readOnly
                      />
                    </div>
                    <div className="Selection_">
                      <label htmlFor="Email">Your email address</label>
                      <input
                        placeholder=""
                        type="text"
                        id="Email"
                        name="Email"
                        value={Email}
                        onChange={(e) => setEmail(e.target.value)}
                        required readOnly
                      />
                    </div>
                    <div className="Selection_">
                      <label htmlFor="number">Your Phone no.</label>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <input
                          placeholder="Enter phone number"
                          type="tel"
                          id="number"
                          name="number"
                          value={phone}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          readOnly={!isEditingPhone}
                          style={{
                            backgroundColor: isEditingPhone ? "#ffffff" : "#edf1f4",
                            borderColor: isEditingPhone ? "#145C91" : "#c7c7c7",
                            flex: 1,
                          }}
                        />
                        {!isEditingPhone ? (
                          <button
                            type="button"
                            onClick={() => setIsEditingPhone(true)}
                            style={{
                              backgroundColor: "#145C91",
                              color: "white",
                              border: "none",
                              padding: "10px 16px",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontFamily: "Open Sans",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Edit
                          </button>
                        ) : (
                          <div style={{ display: "flex", gap: "6px" }}>
                            <button
                              type="button"
                              onClick={handlePhoneSave}
                              disabled={savingPhone}
                              style={{
                                backgroundColor: "#145C91",
                                color: "white",
                                border: "none",
                                padding: "10px 16px",
                                borderRadius: "4px",
                                cursor: savingPhone ? "not-allowed" : "pointer",
                                fontFamily: "Open Sans",
                                fontSize: "13px",
                                opacity: savingPhone ? 0.6 : 1,
                              }}
                            >
                              {savingPhone ? "Saving..." : "Save"}
                            </button>
                            <button
                              type="button"
                              onClick={() => setIsEditingPhone(false)}
                              style={{
                                backgroundColor: "#ffffff",
                                color: "#333",
                                border: "1px solid #c7c7c7",
                                padding: "10px 16px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontFamily: "Open Sans",
                                fontSize: "13px",
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="Selection_">
                      <label>Address</label>
                      <input
                        placeholder="No address on file"
                        type="text"
                        value={[address.street, address.city, address.state, address.zip, address.country].filter(Boolean).join(', ') || ''}
                        readOnly
                        style={{ backgroundColor: "#edf1f4" }}
                      />
                    </div>
                    {/* <div className="Selection_">
                      <span>CHANGE PASSWORD</span>
                      <label htmlFor="oldPassword">Old Password</label>
                      <input
                        placeholder="Enter Old Password"
                        type="password"
                        id="oldPassword"
                        name="oldPassword"
                        required
                      />
                    </div>
                    <div className="Selection_">
                      <span><br /></span>
                      <label htmlFor="newPassword">New Password</label>
                      <input
                        placeholder="Enter New Password"
                        type="password"
                        id="newPassword"
                        name="newPassword"
                        required
                      />
                    </div> */}
                  </div>
                  {/* <div className="LAst_btn">
                    <input type="submit" value="Submit" />
                  </div> */}
                </form>
              )}
            </div>
          </div>

          <div
            className={`Information ${activeSection === "UserPreferences" ? "" : "d-none"}`}
          >
            <div className="PersonalInformation_In UserPreferences">
              <div className="preferences-container">
                <div>
                  <h1 className="personal_information">User Preferences</h1>
                  <p>This includes your user preferences</p>
                </div>
                <div>
                  {!isEditing ? (
                    <button className="edit-button-preferences" onClick={handleEditClick}>Edit Preferences</button>
                  ) : (
                    <button className="edit-button-preferences" onClick={() => setIsEditing(false)}>Cancel Edit</button>
                  )}
                </div>
              </div>
              {loading ? (
                <div className="loader"></div>
              ) : (
                <form onSubmit={handlePreferencesSubmit} className="Personal_details">
                  <div className="Selection_">
                    <label htmlFor="language">Preferred Language</label>
                    <select
                      name="language"
                      id="language"
                      value={preferences.language}
                      onChange={(e) => setPreferences(prev => ({ ...prev, language: e.target.value }))}
                      required
                      disabled={!isEditing}
                    >
                      <option value="">--None--</option>
                      <option value="English (United States)">English (United States)</option>
                      <option value="Spanish">Spanish</option>
                    </select>
                  </div>

                  <div className="Selection_">
                    <label htmlFor="timeFormat">Preferred Time Format</label>
                    <select
                      name="timeFormat"
                      id="timeFormat"
                      value={preferences.timeFormat}
                      onChange={(e) => setPreferences(prev => ({ ...prev, timeFormat: e.target.value }))}
                      required
                      disabled={!isEditing}
                    >
                      <option value="">--None--</option>
                      <option value="12Hours">12 Hours</option>
                      <option value="24Hours">24 Hours</option>
                    </select>
                  </div>
                  <div className="Selection_">
                    <label htmlFor="timeZone">Preferred Time Zone</label>
                    <select
                      name="timeZone"
                      id="timeZone"
                      value={preferences.timeZone}
                      onChange={(e) => setPreferences(prev => ({ ...prev, timeZone: e.target.value }))}
                      required
                      disabled={!isEditing}
                    >
                      <option value="">--None--</option>
                      <option value="(GMT-10:00) Hawaii Standard Time">(GMT-10:00) Hawaii Standard Time</option>
                      <option value="(GMT-9:00) Alaska Standard Time">(GMT-9:00) Alaska Standard Time</option>
                      <option value="(GMT-8:00) Pacific Standard Time">(GMT-8:00) Pacific Standard Time</option>
                      <option value="(GMT-7:00) Mountain Standard Time">(GMT-7:00) Mountain Standard Time</option>
                      <option value="(GMT-6:00) Central Standard Time">(GMT-6:00) Central Standard Time</option>
                      <option value="(GMT-5:00) Eastern Standard Time">(GMT-5:00) Eastern Standard Time</option>
                      <option value="(GMT-4:00) Atlantic Standard Time">(GMT-4:00) Atlantic Standard Time</option>
                      <option value="(GMT+0:00) Greenwich Mean Time">(GMT+0:00) Greenwich Mean Time</option>
                      <option value="(GMT+1:00) Central European Time">(GMT+1:00) Central European Time</option>
                      <option value="(GMT+2:00) Eastern European Time">(GMT+2:00) Eastern European Time</option>
                      <option value="(GMT+5:30) India Standard Time">(GMT+5:30) India Standard Time</option>
                      <option value="(GMT+8:00) China Standard Time">(GMT+8:00) China Standard Time</option>
                      <option value="(GMT+9:00) Japan Standard Time">(GMT+9:00) Japan Standard Time</option>
                      <option value="(GMT+10:00) Australian Eastern Time">(GMT+10:00) Australian Eastern Time</option>
                    </select>
                  </div>
                  <div className="Selection_">
                    <label htmlFor="country">Preferred Country</label>
                    <select
                      name="country"
                      id="country"
                      value={preferences.country}
                      onChange={(e) => setPreferences(prev => ({ ...prev, country: e.target.value }))}
                      required
                      disabled={!isEditing}
                    >
                      <option value="">--None--</option>
                      <option value="United States">United States</option>
                      <option value="United Kingdom">United Kingdom</option>
                    </select>
                  </div>
                  <span>PREFERRED NUMBER FORMAT</span>
                  <div className="Selection_">
                    <label htmlFor="grouping">Preferred Grouping</label>
                    <select
                      name="grouping"
                      id="grouping"
                      value={preferences.grouping}
                      onChange={(e) => setPreferences(prev => ({ ...prev, grouping: e.target.value }))}
                      required
                      disabled={!isEditing}
                    >
                      <option value="">--None--</option>
                      <option value="Standard">Standard</option>
                      <option value="Comma">Comma</option>
                    </select>
                  </div>
                  <div className="Selection_">
                    <label htmlFor="decimal">Preferred Decimal</label>
                    <select
                      name="decimal"
                      id="decimal"
                      value={preferences.decimal}
                      onChange={(e) => setPreferences(prev => ({ ...prev, decimal: e.target.value }))}
                      required
                      disabled={!isEditing}
                    >
                      <option value="">--None--</option>
                      <option value="Dot">Dot</option>
                      <option value="Comma">Comma</option>
                    </select>
                  </div>
                  {isEditing && (
                    <div className="LAst_btn">
                      <input type="submit" value="Update" />
                    </div>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profilepersonal;
